import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import apiFetch from "../../utlis/apiFetch"

// Async thunk for fetching notifications
export const fetchNotifications = createAsyncThunk(
  "notifications/fetchNotifications",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token")
      const response = await apiFetch(`${process.env.REACT_APP_API_BASE_URL}/api/notifications`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })

      if (!response.ok) {
        throw new Error("Failed to fetch notifications")
      }

      const data = response._data ?? await response.json()
      return data.body
    } catch (error) {
      return rejectWithValue(error.message)
    }
  },
)

// Async thunk for marking a notification as read
export const readNotification = createAsyncThunk(
  "notifications/readNotification",
  async (notificationId, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token")
      const response = await apiFetch(`${process.env.REACT_APP_API_BASE_URL}/api/notifications/readNotification`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ notificationId }),
      })

      if (!response.ok) {
        throw new Error("Failed to mark notification as read")
      }

      return notificationId
    } catch (error) {
      return rejectWithValue(error.message)
    }
  },
)

const initialState = {
  notifications: [],
  isLoaded: false,
  loading: false,
  error: null,
}

export const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    setNotifications: (state, action) => {
      state.notifications = action.payload
      state.isLoaded = true
    },
    addNotification: (state, action) => {
      // Check if notification already exists to prevent duplicates
      const exists = state.notifications.some((n) => n._id === action.payload._id)
      if (!exists) {
        state.notifications = [action.payload, ...state.notifications]
      }
    },
    updateNotification: (state, action) => {
      state.notifications = state.notifications.map((notification) =>
        notification._id === action.payload.id ? { ...notification, isRead: true } : notification,
      )
    },
    clearNotifications: (state) => {
      state.notifications = []
      state.isLoaded = false
    },
    setAllNotifications: (state, action) => {
      state.list = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle fetchNotifications
      .addCase(fetchNotifications.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        state.notifications = action.payload
        state.isLoaded = true
        state.loading = false
      })
      .addCase(fetchNotifications.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      // Handle readNotification
      .addCase(readNotification.fulfilled, (state, action) => {
        state.notifications = state.notifications.map((notification) =>
          notification._id === action.payload ? { ...notification, isRead: true } : notification,
        )
      })
  },
})

export const { setNotifications, addNotification, updateNotification, clearNotifications,setAllNotifications } = notificationsSlice.actions

export default notificationsSlice.reducer
